/**
 * /lib/utils.ts
 * 
 * Common helper functions
 */
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Utility function to combine class names conditionally.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Safely extracts error information from an unknown error object.
 * @param e The unknown error object.
 * @returns An object containing the error name and message.
 */
export function toSafeErr(e: unknown) {
  if (e instanceof Error) return { name: e.name, message: e.message };
  return { name: "UnknownError", message: String(e) };
}